import {X} from 'lucide-react'
import { FormEvent, useState } from 'react'
import { lumi } from '@/lib/lumi'

interface PaymentModalProps {
  isOpen: boolean
  onClose: () => void
}

function PaymentModal({ isOpen, onClose }: PaymentModalProps) {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')

  if (!isOpen) return null

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    
    try {
      // Сохраняем лид в базу данных
      await lumi.entities.leads.create({
        name,
        email,
        status: 'new',
        creator: 'system',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      })
      console.log('Lead saved successfully')
    } catch (error) {
      console.error('Failed to save lead:', error)
      // Продолжаем процесс оплаты даже если не удалось сохранить лид
    }
    
    // Создаем форму программно для отправки на ЮKassa
    const form = document.createElement('form')
    form.method = 'post'
    form.action = 'https://yookassa.ru/integration/simplepay/payment'
    form.acceptCharset = 'utf-8'

    // Товар
    const inputs = [
      { name: 'text', value: 'Планер Намерений' },
      { name: 'price', value: '590' },
      { name: 'quantity', value: '1' },
      { name: 'paymentSubjectType', value: 'commodity' },
      { name: 'paymentMethodType', value: 'full_prepayment' },
      { name: 'tax', value: '1' },
      { name: 'cps_email', value: email },
      { name: 'customerNumber', value: name },
      { name: 'sum', value: '590' },
      { name: 'shopId', value: '1254399' },
    ]

    inputs.forEach(({ name, value }) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl p-8 sm:p-12 max-w-md w-full border-4 border-[#1E2B3C] animate-fade-in">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Закрыть"
        >
          <X className="w-6 h-6" />
        </button>

        <h3 className="text-2xl sm:text-3xl font-black text-[#1E2B3C] mb-2 uppercase text-center">
          ПОСЛЕДНИЙ ШАГ
        </h3>
        <p className="text-gray-600 text-center mb-8">
          Заполни данные для получения планера
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="name" className="block text-sm font-bold text-[#1E2B3C] mb-2 uppercase">
              Имя
            </label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg text-lg focus:outline-none focus:border-[#F45B3C] transition-colors"
              placeholder="Как тебя зовут?"
              required
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-sm font-bold text-[#1E2B3C] mb-2 uppercase">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg text-lg focus:outline-none focus:border-[#F45B3C] transition-colors"
              placeholder="Куда прислать планер?"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-[#F45B3C] text-white font-black px-8 py-5 rounded-lg text-xl hover:bg-[#D32F2F] transition-all duration-200 hover:shadow-2xl hover:-translate-y-1 shadow-lg uppercase"
          >
            ПЕРЕЙТИ К ОПЛАТЕ
          </button>
        </form>
      </div>
    </div>
  )
}

export default PaymentModal
